// extracted by mini-css-extract-plugin
export var container = "CarouselContent_container__4vZ9R";
export var productCarousel = "CarouselContent_productCarousel__DFdAF";
export var reviewCarousel = "CarouselContent_reviewCarousel__z0k9J";